export default "__VITE_ASSET__BqnVWZEd__"